
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 60"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","width":"65","height":"74","x":"-3","y":"-10","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dx":"-3","dy":"3","in":"SourceGraphic","result":"FeOffset1028Out"}}),_c('feGaussianBlur',{attrs:{"in":"FeOffset1028Out","result":"FeGaussianBlur1029Out","stdDeviation":"0 0"}})]),_c('mask',{attrs:{"id":"b","width":"2","height":"2","x":"-1","y":"-1"}},[_c('path',{attrs:{"fill":"#fff","d":"M10 0h42v51H10z"}}),_c('path',{attrs:{"d":"M14.906.5a4.553 4.553 0 00-4.546 4.546v40.926a4.555 4.555 0 004.546 4.546H46.74a4.553 4.553 0 004.546-4.546V14.139L37.644.5z"}})])]),_c('path',{attrs:{"fill":"#e8e8e8","d":"M4.907 9.5A4.553 4.553 0 00.36 14.046v40.926a4.555 4.555 0 004.546 4.546H36.74a4.553 4.553 0 004.546-4.546V23.139L27.643 9.5z"}}),_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"fill":"none","d":"M14.906.5a4.553 4.553 0 00-4.546 4.546v40.926a4.555 4.555 0 004.546 4.546H46.74a4.553 4.553 0 004.546-4.546V14.139L37.644.5z","mask":"url(\"#b\")"}}),_c('path',{attrs:{"fill-opacity":".02","d":"M14.906.5a4.553 4.553 0 00-4.546 4.546v40.926a4.555 4.555 0 004.546 4.546H46.74a4.553 4.553 0 004.546-4.546V14.139L37.644.5z"}})]),_c('path',{attrs:{"fill":"#ececec","d":"M14.906.5a4.553 4.553 0 00-4.546 4.546v40.926a4.555 4.555 0 004.546 4.546H46.74a4.553 4.553 0 004.546-4.546V14.139L37.644.5z"}}),_c('g',[_c('path',{attrs:{"fill":"#dcdcdc","d":"M51.29 14.14L37.65.5v9.09a4.554 4.554 0 004.546 4.55z"}})])])
          )
        }
      }
    